import * as Yup from 'yup';

import { reviewSchema } from './review';

export const reviewsSchema = Yup.object().shape({
  reviews: Yup.array(reviewSchema).required().default([]),
  hasMore: Yup.boolean().required().default(undefined),
  offset: Yup.number().required().default(0),
  limit: Yup.number().required().default(0),
});

export type ReviewsSchema = Yup.InferType<typeof reviewsSchema>;
